var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 7884"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1179_27004)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.166748,
    y: 0.666016,
    width: 26.6667,
    height: 26.6667,
    rx: 13.3333,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.9964 14.0808C26.9964 6.67203 20.9904 0.666016 13.5816 0.666016C6.17276 0.666016 0.166748 6.67203 0.166748 14.0808C0.166748 20.7765 5.07233 26.3263 11.4855 27.3327V17.9586H8.07939V14.0808H11.4855V11.1254C11.4855 7.76329 13.4883 5.90618 16.5525 5.90618C18.0197 5.90618 19.5554 6.16819 19.5554 6.16819V9.46949H17.8638C16.1975 9.46949 15.6776 10.5036 15.6776 11.5656V14.0808H19.3981L18.8034 17.9586H15.6776V27.3327C22.0908 26.3263 26.9964 20.7765 26.9964 14.0808Z",
    fill: "#1877F2"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1179_27004"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.166748,
    y: 0.666016,
    width: 26.6667,
    height: 26.6667,
    rx: 13.3333,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.bb5952375920bbbf76d24ba099e2b6c3.svg";
export { ForwardRef as ReactComponent };